import AdaptiveImage from "../../../react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/up.ad0fa1c5.png","uri@2x": __webpack_public_path__ + "static/media/up.3f8a8cf2.png","uri@3x": __webpack_public_path__ + "static/media/up.bb2b3f81.png",
    width: 10,
    height: 12
});